import type { FaireProductEntity } from "../../entity_types/product";

export const p_zpveuav8b6: FaireProductEntity = {
  token: "p_zpveuav8b6",
  type: "product",
  name: "Halloween Ghost Storytime Mini Chunky 2026",
  brandToken: "b_c8gh4g2kci",
  brandName: "FINE & RAW",
  imageUrl:
    "https://cdn.faire.com/fastly/6353ef9c3aad39ed8595a31822480ad4434dd1d842c9c074e7a092c20b154fb8.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.48,
  description:
    "The universe must have invented hazelnuts so they could be paired with chocolate.\n\nOur Mini Hazelnut Chunky is a truffle disguised as a bite-size chocolate bar—crafted with our house-made hazelnut butter, organic cacao, and just a touch of sea salt. Rich, creamy, nutty, and impossibly smooth, it's the kind of chocolate experience that makes hazelnut lovers swoon and everyone else suddenly understand the hype.\n\nPart candy bar, part truffle, all bliss.\n\nWrapped in playful Halloween artwork by Yusuke Okada, this seasonal favorite delivers big flavor in a perfectly snackable package.\n\n**Product Highlights:**\n• 1.5 oz truffle disguised as a chocolate bar\n• Made with house-made hazelnut butter\n• Organic, bean-to-bar chocolate\n• Vegan-friendly & gluten-free\n• Small-batch crafted in Brooklyn, NY\n• Seasonal Halloween artwork by Yusuke Okada\n• Perfect for gifting, checkout displays, and impulse purchases\n\n**Ingredients:** Organic cacao bean, organic coconut sugar, organic hazelnuts, organic cacao butter, and sea salt.\n\nCreamy. Nutty. Dreamy. The stuff of hazelnut legends.\n",
  tags: [],
  msrpDollars: 4.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:31.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
